<script>
import ProInput from '$common/ProInput'
export default {
  name: 'CreateGuardian',
  components: {
    'pro-input': ProInput,
  },
  props: {
    options: {
      required: true,
    }
  },
  data () {
    return {
      guardian: {
        name: '',
        email: '',
        phone: '',
      },
      formOptions: {
        name: {
          title: 'First and Last Name',
          errorIf: (val) => val ? '' : 'Enter guardian\'s name',
        },
        email: {
          title: 'Email',
          errorIf: (val) => {
            return this.$regex.is(val).a('email') ? '' : 'Enter guardian\'s valid email'
          },
        },
        phone: {
          title: 'Cell Phone Number',
          errorIf: (val) => '',
        },
      },
      editing: false,
      saving: false,
    }
  },
  methods: {
    async onSubmit(){
      const errors = await this.getErrors()
      if (errors.length) return errors.forEach(err => this.$toast({copy: err, class: 'alert'}))
      this.saving = true

      if (this.editing) {
        try {
          await Promise.resolve(this.$firestore.collection('users').doc(this.options.info.id).update({...this.guardian}))
        } catch (e) {
          console.error(e)
          this.$toast('Guardian did nto save. Please try again')
          this.saving = false
          return
        }
      } else {
        // generate 10 random characters so we can create an auth
        // will need to send a password reset to guardian afterwards
        const tempPassword = [...Array(10)].map(i=>(~~(Math.random()*36)).toString(36)).join('')

        try {
          await this.$HTTP({
            method: 'post',
            uri: 'users',
            body: {
              form: {guardian: this.guardian},
              password: tempPassword,
              createdByAdmin: true,
            },
            secure: false,
          })
        } catch (e) {
          console.error(e)
          this.$toast({
            copy: e.body.message,
            class: 'alert'
          })
          this.saving = false
          return
        }
      }
      
      this.$toast(`Guardian ${this.editing ? 'updated' : 'created'}.`)
      this.$modals.hide('create-guardian')

      const successFunc = this.options.onSuccess
      if (successFunc) successFunc()
    },
    getErrors () {
      return new Promise(async (resolve, reject) => {
        const checkErrorIfs = () => Object.keys(this.guardian)
          .map(key => this.formOptions[key].errorIf(this.guardian[key]))
          .filter(Boolean)

        const guardianErrors = checkErrorIfs()

        // check if guardian email already in use
        try {
          const signInMethods = await this.$auth.fetchSignInMethodsForEmail(this.guardian.email)
          if (signInMethods.length) guardianErrors.push('Guardian email already in use')
        } catch (e) {
          guardianErrors.push(e.message)
        }

        resolve([
          ...guardianErrors,
        ])
      })
    },
  },
  mounted () {
    if (this.options.info) {
      this.editing = true
      Object.keys(this.guardian).forEach((key) => this.guardian[key] = this.options.info[key])
    }
  },
}
</script>

<template lang="pug">
  #note-main.modal-main
    .note-container.modal-container
      .title {{editing ? 'Edit' : 'Create'}} Guardian
      .content
        .notes-section
          .form-holder
            .pro-form
              .row-title Parent/Guardian Information
              .form-row(
                v-for='(options, key, idx) in formOptions'
              )
                pro-input(
                  v-if='key !== "email" || !editing'
                  :options='options'
                  v-model='guardian[key]'
                )
                // disable email editing for now until we have the time 
                // to set up email validation since auth is tied to emails
                .notification(v-else) Note: Editing email ({{guardian.email}}) after creation currently disabled.
      .action
        .button.minor(
          @click='$modals.hide(`create-guardian`)'
        ) Cancel
        span
        .button.major(
          @click='onSubmit'
        ) {{saving ? 'Saving...' : 'Save'}}
</template>

<style lang="sass" scoped>
  .notification
    color: grey
    margin-bottom: 2rem
</style>